import SetupHuawei from "./steps/huawei_server/SetupHuawei";
import SetupIotDatabase from "./steps/iot_server";
import SelectServer from "./steps/selectServer";
import { useState,useEffect } from "react";
import { useTranslation } from 'react-i18next'

const SetupServer = ({server, onClose, isEditServer, plantId}) => {
  const [step, setStep] = useState(1);
  const [serverDetails, setSeverDetails] = useState({});
  const { t } = useTranslation("settings");

  useEffect(() => {
    if (isEditServer) {
      setSeverDetails(server)
    }
  }, [])

  
    return ( 
      
        <section className={''}>
          <div className="bg-black bg-opacity-60 fixed z-50 left-0 top-0 w-[100%] h-[100%] overflow-hidden flex items-center justify-center">
            <div className="flex flex-col w-[70%] lg:w-1/2 2xl:w-[30%] gap-4 p-8 bg-white rounded-md">

              <div className="flex flex-row items-center justify-between">
              <h2 className="font-bold">{t('device_management.server_setup.title')}</h2>
              <button className="" type="button" onClick={()=>onClose(false)}><i className="text-xl ri-close-line"></i></button>
                
              </div>
              <hr></hr>
              
            <div className="w-full">
              <SelectServer step={step} setStep={setStep} setSeverDetails={setSeverDetails} type={serverDetails?.type} onClose={onClose}/>
              <SetupIotDatabase  isEditServer={isEditServer} step={step} setStep={setStep} type={serverDetails?.type} server={serverDetails}  onClose={onClose} plantId={plantId}/>
              <SetupHuawei  isEditServer={isEditServer} step={step} setStep={setStep} type={serverDetails?.type} server={serverDetails}  onClose={onClose}/>
            </div>
            </div>
          </div>
        </section>

     );
}
 
export default SetupServer;